/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HowToPlayRouteImport } from './routes/how-to-play'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as LobbyRouteImport } from './routes/lobby'
import { Route as PlayRouteImport } from './routes/play'
import { Route as SavesRouteImport } from './routes/saves'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PlayMultiRouteImport } from './routes/play.multi'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const HowToPlayRoute = HowToPlayRouteImport.update({
  id: '/how-to-play',
  path: '/how-to-play',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaderboardRoute = LeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const LobbyRoute = LobbyRouteImport.update({
  id: '/lobby',
  path: '/lobby',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const SavesRoute = SavesRouteImport.update({
  id: '/saves',
  path: '/saves',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayMultiRoute = PlayMultiRouteImport.update({
  id: '/multi',
  path: '/multi',
  getParentRoute: () => PlayRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/how-to-play': typeof HowToPlayRoute
  '/leaderboard': typeof LeaderboardRoute
  '/lobby': typeof LobbyRoute
  '/play': typeof PlayRouteWithChildren
  '/saves': typeof SavesRoute
  '/settings': typeof SettingsRoute
  '/play/multi': typeof PlayMultiRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/how-to-play': typeof HowToPlayRoute
  '/leaderboard': typeof LeaderboardRoute
  '/lobby': typeof LobbyRoute
  '/play': typeof PlayRouteWithChildren
  '/saves': typeof SavesRoute
  '/settings': typeof SettingsRoute
  '/play/multi': typeof PlayMultiRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/how-to-play': typeof HowToPlayRoute
  '/leaderboard': typeof LeaderboardRoute
  '/lobby': typeof LobbyRoute
  '/play': typeof PlayRouteWithChildren
  '/saves': typeof SavesRoute
  '/settings': typeof SettingsRoute
  '/play/multi': typeof PlayMultiRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/how-to-play'
    | '/leaderboard'
    | '/lobby'
    | '/play'
    | '/saves'
    | '/settings'
    | '/play/multi'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/how-to-play'
    | '/leaderboard'
    | '/lobby'
    | '/play'
    | '/saves'
    | '/settings'
    | '/play/multi'
  id:
    | '__root__'
    | '/'
    | '/how-to-play'
    | '/leaderboard'
    | '/lobby'
    | '/play'
    | '/saves'
    | '/settings'
    | '/play/multi'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HowToPlayRoute: typeof HowToPlayRoute
  LeaderboardRoute: typeof LeaderboardRoute
  LobbyRoute: typeof LobbyRoute
  PlayRoute: typeof PlayRouteWithChildren
  SavesRoute: typeof SavesRoute
  SettingsRoute: typeof SettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/how-to-play': {
      id: '/how-to-play'
      path: '/how-to-play'
      fullPath: '/how-to-play'
      preLoaderRoute: typeof HowToPlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lobby': {
      id: '/lobby'
      path: '/lobby'
      fullPath: '/lobby'
      preLoaderRoute: typeof LobbyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/saves': {
      id: '/saves'
      path: '/saves'
      fullPath: '/saves'
      preLoaderRoute: typeof SavesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/multi': {
      id: '/play/multi'
      path: '/multi'
      fullPath: '/play/multi'
      preLoaderRoute: typeof PlayMultiRouteImport
      parentRoute: typeof PlayRoute
    }
  }
}

interface PlayRouteChildren {
  PlayMultiRoute: typeof PlayMultiRoute
}

const PlayRouteChildren: PlayRouteChildren = {
  PlayMultiRoute: PlayMultiRoute,
}

const PlayRouteWithChildren = PlayRoute._addFileChildren(PlayRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HowToPlayRoute: HowToPlayRoute,
  LeaderboardRoute: LeaderboardRoute,
  LobbyRoute: LobbyRoute,
  PlayRoute: PlayRouteWithChildren,
  SavesRoute: SavesRoute,
  SettingsRoute: SettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
